<template>
  <div class="setup">
    <div class="input_">
      <label>
        Expense Name:
      </label>
      <input type="text" class="expanse" v-model="name" />
    </div>
    <div class="input_">
      <label>
        AMT:
        <input type="text" v-model="amt" />
      </label>
    </div>
    <div class="input_">
      <label>
        Category:
      </label>
      <div class="select_">
        <div class="wrapper" @click="dropdown = !dropdown">
          {{ category ? category : "Select" }}
          <span class="ico">
            <svg
              width="8"
              height="5"
              viewBox="0 0 8 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L4 4L7 1"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
        <div class="options_" v-if="dropdown">
          <div v-for="categ in categories" @click="category = categ">
            {{ categ }}
          </div>
          <div class="add-new">
            <input
              type="text"
              placeholder="Add  New"
              v-model="newOpt"
              @keypress.enter="addNewOpt"
            />
            <span
              class="ico"
              :class="{ disabled: newOpt.length <= 0 }"
              @click="addNewOpt"
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 5H9"
                  :stroke="newOpt.length > 0 ? '#000' : '#A0A0A0'"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 9L5 1"
                  :stroke="newOpt.length > 0 ? '#000' : '#A0A0A0'"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-if="dropdown" @click="dropdown = false"></div>
    <div class="input_">
      <label>
        Frequency:
        <input type="text" v-model="frequency" />
      </label>
    </div>
    <button
      class="btn-setup"
      :class="{ disabled: notValidated }"
      @click="addSetup"
    >
      Add
    </button>
  </div>
</template>

<script>
export default {
  name: "BaseSetup.vue",
  data() {
    return {
      category: null,
      dropdown: false,
      newOpt: "",
      name: "",
      amt: "",
      frequency: "",
      categories: ["Housing", "Auto", "Investment"]
    };
  },
  watch: {
    category() {
      this.dropdown = false;
    }
  },
  methods: {
    addNewOpt() {
      if (this.newOpt.length > 0) {
        this.categories.push(this.newOpt);
        this.newOpt = "";
      }
    },
    addSetup() {
      this.$emit("baselineAdded", {
        category: this.category,
        name: this.name,
        amt: this.amt,
        frequency: this.frequency
      });
      this.category = null;
      this.name = "";
      this.amt = "";
      this.frequency = "";
    }
  },
  computed: {
    notValidated() {
      return this.name.length > 0 &&
        this.frequency.length > 0 &&
        this.category != null &&
        this.amt.length > 0
        ? false
        : true;
    }
  }
};
</script>

<style lang="scss" scoped>
.setup {
  .input_ {
    display: flex;
    //flex-direction: column;
    align-items: center;
    height: 35px;
    label {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      color: #bfbfbf;
      word-break: keep-all;
    }
    input {
      padding-left: 6px;
      margin-top: -4px;
      border: none;
      background: none;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      color: #171e4e;
      &.expanse {
        width: 100px;
      }
      &:focus {
        outline: none;
      }
    }
  }
  .select_ {
    margin-top: -4px;
    margin-left: 4px;
    width: 116px;
    height: 16px;
    background: #bebebe;
    border-radius: 20px;
    position: relative;
    .wrapper {
      cursor: pointer;
      position: relative;
      font-style: normal;
      font-weight: normal;
      font-size: 9px;
      line-height: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      height: 100%;
      .ico {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 6px;
      }
    }
    .options_ {
      padding: 6px;
      top: 100%;
      position: absolute;
      width: 117px;
      //height: 80px;
      z-index: 2;
      background: #ffffff;
      box-shadow: 4px 4px 20px rgba(18, 20, 59, 0.08);
      border-radius: 8px;
      font-style: normal;
      font-weight: bold;
      font-size: 10px;
      line-height: 14px;

      & > div {
        margin: 3px 0;
        cursor: pointer;
        &:nth-child(1) {
          color: #00abe0;
        }
        &:nth-child(2) {
          color: #4357e0;
        }
        &:nth-child(3) {
          color: #ff7258;
        }
      }
      .add-new {
        display: flex;
        justify-content: center;
        cursor: unset !important;
        .ico {
          cursor: pointer;
          position: absolute;
          right: 2px;
          bottom: 6px;
          &.disabled {
            pointer-events: none;
            cursor: default !important;
          }
        }
      }
      input {
        //border: 1px solid;
        width: 80px;
        text-align: center;
        font-style: normal;
        font-weight: bold;
        font-size: 9px;
        line-height: 12px;
        color: #a1a1a1;
        margin-bottom: -3px;
        margin-top: 4px;
      }
    }
  }
}
.btn-setup {
  width: 194px;
  height: 20px;

  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  box-shadow: 4px 4px 20px rgba(16, 25, 60, 0.1);
  &.disabled {
    color: #bdc1c5;
    background: #eceff9;
  }
  color: #fff;
  background: #8d97e0;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
</style>
